export const MAX_PHONE_NUMBERS = 11;
export const DESCRIPTION_MAX_LENGTH = 800;

export const MIN_MANUAL_PHONE_LENGTH = 3;
export const MAX_MANUAL_PHONE_LENGTH = 20;
